import { useState } from 'react';

import { createPolling } from '../utils/polling';

export function usePolling(provided) {
  const [controller] = useState(provided || createPolling);
  return controller;
}
